import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  ogTitle,
  ogDescription,
  ogUrl,
  ogImage,
  twitterTitle,
  twitterDescription,
  twitterImage,
  canonicalUrl
}) => {
  // Define default values
  const defaultTitle = 'Roamzap | Personalized Trip Planning';
  const defaultDescription = 'Plan your perfect vacation with roamzap. Discover hidden gems, local attractions, and tailored recommendations for your dream trip.';
  const defaultKeywords = 'travel planner, trip planner, vacation planner, AI powered travel, personalized travel, trip generator, holiday planning, vacation planning';
  const defaultOgImage = 'https://roamzap.com/og-image.jpg';
  const defaultUrl = 'https://roamzap.com';

  // Use provided values or defaults
  const metaTitle = title || defaultTitle;
  const metaDescription = description || defaultDescription;
  const metaKeywords = keywords || defaultKeywords;
  const metaOgTitle = ogTitle || metaTitle;
  const metaOgDescription = ogDescription || metaDescription;
  const metaOgUrl = ogUrl || defaultUrl;
  const metaOgImage = ogImage || defaultOgImage;
  const metaTwitterTitle = twitterTitle || metaOgTitle;
  const metaTwitterDescription = twitterDescription || metaOgDescription;
  const metaTwitterImage = twitterImage || metaOgImage;
  const metaCanonicalUrl = canonicalUrl || defaultUrl;

  return (
    <Helmet>
      {/* Basic Metadata */}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:title" content={metaOgTitle} />
      <meta property="og:description" content={metaOgDescription} />
      <meta property="og:url" content={metaOgUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={metaOgImage} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTwitterTitle} />
      <meta name="twitter:description" content={metaTwitterDescription} />
      <meta name="twitter:image" content={metaTwitterImage} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={metaCanonicalUrl} />
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  ogTitle: PropTypes.string,
  ogDescription: PropTypes.string,
  ogUrl: PropTypes.string,
  ogImage: PropTypes.string,
  twitterTitle: PropTypes.string,
  twitterDescription: PropTypes.string,
  twitterImage: PropTypes.string,
  canonicalUrl: PropTypes.string
};

export default SEO; 